import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./QuizPrompt.css";

function QuizPrompt({ onClose }) {
  return (
    <div className="quiz-prompt-popup">
      <p>
        Now that you've planned your night walk route, why not ensure your home
        is secure too? Take our home safety assessment quiz for personalized
        safety tips.
      </p>
      <div className="quiz-prompt-buttons">
        <Link to="/quiz" style={{ textDecoration: "none" }}>
          <button className="btn take-quiz-btn">Take Quiz</button>
        </Link>
        <button className="btn no-thanks-btn" onClick={onClose}>
          No Thanks
        </button>
      </div>
    </div>
  );
}

export default QuizPrompt;
